// skipcq: JS-W1028, JS-0128
import React, { useCallback, useState } from 'react';
// Material UI
import { Box, Container, Grid, Tab, Tabs } from '@mui/material';
// Components
import DashboardLayout from '../../components/layout/DashboardLayout';
import TabPanel from '../../components/tabs/TabPanel';
import HaikuCard from '../../components/dashboard/HaikuCard';
import BreweryManagementCard from '../../components/dashboard/BreweryManagementCard';
import UserManagementCard from '../../components/dashboard/UserManagementCard';
import DataIssuesCard from '../../components/dashboard/DataIssuesCard';
import BeerIngestionIssuesCard from '../../components/dashboard/BeerIngestionIssuesCard';
import BeerDuplicateReviewsCard from '../../components/dashboard/BeerDuplicateReviewsCard';
import SplatManagementCard from '../../components/dashboard/SplatManagementCard';
import ReviewsCard from '../../components/dashboard/ReviewsCard';
import CheckinsCard from '../../components/dashboard/CheckinsCard';
import BeerManagementCard from '../../components/dashboard/BeerManagementCard';
import UserAddedBreweriesCard from '../../components/dashboard/UserAddedBreweriesCard';
import SchedulerSummaryCard from '../../components/dashboard/SchedulerSummaryCard';
import KeyMetricsCard from '../../components/dashboard/KeyMetricsCard';

const DASHBOARD_TABS_CONFIG = [
  {
    index: 0,
    cards: [KeyMetricsCard],
    gridSize: { xs: 12, md: 12, lg: 12 },
  },
  {
    index: 1,
    cards: [
      UserManagementCard,
      ReviewsCard,
      CheckinsCard,
      SplatManagementCard,
      UserAddedBreweriesCard,
    ],
  },
  {
    index: 2,
    cards: [
      BeerManagementCard,
      BreweryManagementCard,
      DataIssuesCard,
      BeerDuplicateReviewsCard,
      BeerIngestionIssuesCard,
      SchedulerSummaryCard,
    ],
  },
  { index: 3, cards: [HaikuCard] },
];

function renderDashboardTabContent(activeTab) {
  return DASHBOARD_TABS_CONFIG.map((tabConfig) => (
    <TabPanel
      key={tabConfig.index}
      value={activeTab}
      index={tabConfig.index}
      disableGutters
    >
      <Grid container spacing={3}>
        {tabConfig.cards.map((CardComponent) => {
          const cardKey =
            CardComponent.displayName ?? CardComponent.name ?? 'card';
          const gridSize = tabConfig.gridSize ?? { xs: 12, md: 6, lg: 4 };
          return (
            <Grid
              item
              {...gridSize}
              key={`dashboard-tab-${String(tabConfig.index)}-${cardKey}`}
            >
              <CardComponent />
            </Grid>
          );
        })}
      </Grid>
    </TabPanel>
  ));
}

function DashboardSectionTabs({ activeTab, onTabChange }) {
  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        mb: 2,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        aria-label="Dashboard section tabs"
      >
        <Tab
          id="simple-tab-0"
          aria-controls="simple-tabpanel-0"
          label="Key Metrics"
        />
        <Tab
          id="simple-tab-1"
          aria-controls="simple-tabpanel-1"
          label="User Activity"
        />
        <Tab
          id="simple-tab-2"
          aria-controls="simple-tabpanel-2"
          label="Data Management"
        />
        <Tab
          id="simple-tab-3"
          aria-controls="simple-tabpanel-3"
          label="Utilities"
        />
      </Tabs>
    </Box>
  );
}

function Dashboard() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = useCallback((event, newValue) => {
    setActiveTab(newValue);
  }, []);

  return (
    <DashboardLayout title="Dashboard">
      <Container maxWidth="lg" sx={{ mt: 3, mb: 5, px: { xs: 2, sm: 3 } }}>
        <DashboardSectionTabs activeTab={activeTab} onTabChange={handleTabChange} />

        {renderDashboardTabContent(activeTab)}
      </Container>
    </DashboardLayout>
  );
}

export default Dashboard;
